import { render } from "./SelectCheckbox.vue?vue&type=template&id=28e5ba80&scoped=true"
import script from "./SelectCheckbox.vue?vue&type=script&lang=js"
export * from "./SelectCheckbox.vue?vue&type=script&lang=js"

import "./SelectCheckbox.vue?vue&type=style&index=0&id=28e5ba80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28e5ba80"

export default script